<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('TITLE')">
        <inputvalidation :formerror="formError" name="title">
          <b-form-input type="text" v-model="formData.title"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('TRAININGBLOCK')">
        <inputvalidation :formerror="formError" name="trainingBlockId">
          <b-form-select :options="trainingBlock.root" v-model="formData.trainingBlockId" value-field="trainingBlockId" text-field="name"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-9">
      <b-form-fieldset v-bind:label="$t('LINKEDQUIZ')">
        <inputvalidation :formerror="formError" name="quizId">
          <b-form-select :options="quiz.root" v-model="formData.quizId" value-field="quizId" text-field="title"></b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-3">
      <b-form-fieldset v-bind:label="$t('ISADVANCE')">
        <b-form-checkbox :plain="true" v-model="formData.isAdvance" value="1" unchecked-value="0">{{$t('ITISADVANCE')}}</b-form-checkbox>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <inputvalidation :formerror="formError" name="name">
        <wysiwyg v-model="formData.content" />
      </inputvalidation>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'TrainingChaptersForm',
  props: ['formData', 'formError', 'quiz', 'trainingBlock'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
